import React, { useState } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles, IconButton
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';

import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "FASTAG DATA SECTION"

const ACTIONS = {
    "CREATE": "#18cc69",
    "UPDATE": "#334d6e",
    "DELETE": "#de575e"
}

export const FasTagApiData = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Plaza Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "PLaza Name");
    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } };
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};
    React.useEffect(() => {
        eventTracker(CATEGORY, "FASTAG DATA LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="FasTag Api Data"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination />}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.plaza_name}
                        secondaryText={record => (<div>
                            {record.api_name && <div><span style={{ color: "#5a5a5a" }}>API Name: </span>{record.api_name}</div>}
                            {record.action && <div style={{ color: ACTIONS[record.action] }}><span style={{ color: "#5a5a5a" }}>Action: </span>{record.action}</div>}
                            {record.timestamp && <div><span style={{ color: "#5a5a5a" }}>Timestamp: </span>{renderTime(record["timestamp"])}</div>}
                            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                {record && record.request_body &&
                                    <DownloadXml text={record.request_body} title="Request Body" />}

                                {record && record.response_body &&
                                    <DownloadXml text={record.response_body} title="Response Body" />
                                }
                                {record && record.response &&
                                    <DownloadXml text={record.response} title="Response" />
                                }
                            </div>
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <TextField source='plaza_name' label="Plaza Name" />
                        <FunctionField source='api_name' label="API Name" render={record => record && <span style={{ fontWeight: "bold" }}>{record.api_name}</span>} />
                        <FunctionField source="timestamp" label="Time" render={record => renderTime(record["timestamp"])} />
                        <FunctionField source='request_body' label="Request Body" render={record => record && record.request_body &&
                            <DownloadXml text={record.request_body} title="Request Body" />
                        } />
                        <FunctionField source='response_body' label="Response Body" render={record => record && record.response_body &&
                            <DownloadXml text={record.response_body} title="Response Body" />
                        } />
                        <FunctionField source='response' label="Response" render={record => record && record.response &&
                            <DownloadXml text={record.response} title="Response" />
                        } />
                    </Datagrid>
            }
        </List>
    </div>
};


const DownloadXml = ({ text, title }) => {
    const download = () => {
        const element = document.createElement("a");
        const file = new Blob([text], {
            type: "text/plain"
        });
        element.href = URL.createObjectURL(file);
        element.download = "responseFile.txt";
        document.body.appendChild(element);
        element.click();
    };
    return (
        <IconButton title={title} onClick={download}>
            <GetAppIcon />
        </IconButton>
    );
}